"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _grid = require("@rebass/grid");
var _format = _interopRequireDefault(require("date-fns/format"));
var _is_valid = _interopRequireDefault(require("date-fns/is_valid"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _shuffle = _interopRequireDefault(require("lodash/shuffle"));
var _size = _interopRequireDefault(require("lodash/size"));
var _take = _interopRequireDefault(require("lodash/take"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _filmStrip = _interopRequireDefault(require("@gravity/film-strip"));
var _product = require("@gravity/product");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product2 = require("@nucleo/product");
var _productList = require("@nucleo/product-list");
var _section = require("@nucleo/section");
var _withThemeQueries = require("@gravity/utils/lib/withThemeQueries");
var _reactDeviceDetect = require("react-device-detect");
var _helper = require("./helper");
var _jsxFileName = "/codebuild/output/src3264043598/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/SectionCluster.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1p1ey67r80() {
  var path = "/codebuild/output/src3264043598/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/SectionCluster.js";
  var hash = "a0a57b96ec75561c8fd25ac14649f137723a6eb3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3264043598/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/SectionCluster.js",
    statementMap: {
      "0": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 131,
          column: 1
        }
      },
      "1": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 59,
          column: 9
        }
      },
      "2": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 73,
          column: 7
        }
      },
      "3": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 94,
          column: 13
        }
      },
      "4": {
        start: {
          line: 132,
          column: 22
        },
        end: {
          line: 142,
          column: 2
        }
      },
      "5": {
        start: {
          line: 143,
          column: 27
        },
        end: {
          line: 145,
          column: 1
        }
      },
      "6": {
        start: {
          line: 146,
          column: 27
        },
        end: {
          line: 146,
          column: 39
        }
      },
      "7": {
        start: {
          line: 148,
          column: 19
        },
        end: {
          line: 183,
          column: 1
        }
      },
      "8": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 163,
          column: 56
        }
      },
      "9": {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 85
        }
      },
      "10": {
        start: {
          line: 184,
          column: 21
        },
        end: {
          line: 188,
          column: 1
        }
      },
      "11": {
        start: {
          line: 185,
          column: 21
        },
        end: {
          line: 185,
          column: 94
        }
      },
      "12": {
        start: {
          line: 186,
          column: 23
        },
        end: {
          line: 186,
          column: 64
        }
      },
      "13": {
        start: {
          line: 187,
          column: 2
        },
        end: {
          line: 187,
          column: 36
        }
      },
      "14": {
        start: {
          line: 189,
          column: 16
        },
        end: {
          line: 197,
          column: 1
        }
      },
      "15": {
        start: {
          line: 196,
          column: 25
        },
        end: {
          line: 196,
          column: 44
        }
      },
      "16": {
        start: {
          line: 199,
          column: 16
        },
        end: {
          line: 227,
          column: 1
        }
      },
      "17": {
        start: {
          line: 229,
          column: 25
        },
        end: {
          line: 233,
          column: 1
        }
      },
      "18": {
        start: {
          line: 235,
          column: 25
        },
        end: {
          line: 247,
          column: 1
        }
      },
      "19": {
        start: {
          line: 236,
          column: 16
        },
        end: {
          line: 236,
          column: 46
        }
      },
      "20": {
        start: {
          line: 238,
          column: 2
        },
        end: {
          line: 240,
          column: 3
        }
      },
      "21": {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 31
        }
      },
      "22": {
        start: {
          line: 242,
          column: 2
        },
        end: {
          line: 244,
          column: 3
        }
      },
      "23": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 243,
          column: 28
        }
      },
      "24": {
        start: {
          line: 246,
          column: 2
        },
        end: {
          line: 246,
          column: 25
        }
      },
      "25": {
        start: {
          line: 249,
          column: 23
        },
        end: {
          line: 262,
          column: 1
        }
      },
      "26": {
        start: {
          line: 250,
          column: 2
        },
        end: {
          line: 261,
          column: 5
        }
      },
      "27": {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 254,
          column: 5
        }
      },
      "28": {
        start: {
          line: 253,
          column: 6
        },
        end: {
          line: 253,
          column: 56
        }
      },
      "29": {
        start: {
          line: 255,
          column: 4
        },
        end: {
          line: 260,
          column: 5
        }
      },
      "30": {
        start: {
          line: 256,
          column: 6
        },
        end: {
          line: 259,
          column: 9
        }
      },
      "31": {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 35
        }
      },
      "32": {
        start: {
          line: 292,
          column: 32
        },
        end: {
          line: 295,
          column: 3
        }
      },
      "33": {
        start: {
          line: 293,
          column: 20
        },
        end: {
          line: 293,
          column: 93
        }
      },
      "34": {
        start: {
          line: 294,
          column: 4
        },
        end: {
          line: 294,
          column: 83
        }
      },
      "35": {
        start: {
          line: 298,
          column: 2
        },
        end: {
          line: 427,
          column: 5
        }
      },
      "36": {
        start: {
          line: 299,
          column: 67
        },
        end: {
          line: 299,
          column: 71
        }
      },
      "37": {
        start: {
          line: 300,
          column: 15
        },
        end: {
          line: 300,
          column: 85
        }
      },
      "38": {
        start: {
          line: 302,
          column: 27
        },
        end: {
          line: 302,
          column: 74
        }
      },
      "39": {
        start: {
          line: 305,
          column: 25
        },
        end: {
          line: 305,
          column: 81
        }
      },
      "40": {
        start: {
          line: 306,
          column: 30
        },
        end: {
          line: 306,
          column: 62
        }
      },
      "41": {
        start: {
          line: 307,
          column: 27
        },
        end: {
          line: 307,
          column: 80
        }
      },
      "42": {
        start: {
          line: 310,
          column: 6
        },
        end: {
          line: 320,
          column: 11
        }
      },
      "43": {
        start: {
          line: 322,
          column: 29
        },
        end: {
          line: 322,
          column: 56
        }
      },
      "44": {
        start: {
          line: 324,
          column: 6
        },
        end: {
          line: 324,
          column: 89
        }
      },
      "45": {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 326,
          column: 88
        }
      },
      "46": {
        start: {
          line: 327,
          column: 24
        },
        end: {
          line: 327,
          column: 80
        }
      },
      "47": {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 329,
          column: 89
        }
      },
      "48": {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 357,
          column: 5
        }
      },
      "49": {
        start: {
          line: 331,
          column: 6
        },
        end: {
          line: 356,
          column: 8
        }
      },
      "50": {
        start: {
          line: 359,
          column: 4
        },
        end: {
          line: 381,
          column: 5
        }
      },
      "51": {
        start: {
          line: 360,
          column: 6
        },
        end: {
          line: 380,
          column: 8
        }
      },
      "52": {
        start: {
          line: 383,
          column: 73
        },
        end: {
          line: 383,
          column: 83
        }
      },
      "53": {
        start: {
          line: 385,
          column: 23
        },
        end: {
          line: 385,
          column: 75
        }
      },
      "54": {
        start: {
          line: 386,
          column: 24
        },
        end: {
          line: 386,
          column: 35
        }
      },
      "55": {
        start: {
          line: 388,
          column: 4
        },
        end: {
          line: 426,
          column: 6
        }
      },
      "56": {
        start: {
          line: 440,
          column: 8
        },
        end: {
          line: 440,
          column: 13
        }
      },
      "57": {
        start: {
          line: 443,
          column: 20
        },
        end: {
          line: 443,
          column: 27
        }
      },
      "58": {
        start: {
          line: 444,
          column: 4
        },
        end: {
          line: 446,
          column: 5
        }
      },
      "59": {
        start: {
          line: 445,
          column: 6
        },
        end: {
          line: 445,
          column: 69
        }
      },
      "60": {
        start: {
          line: 445,
          column: 35
        },
        end: {
          line: 445,
          column: 67
        }
      },
      "61": {
        start: {
          line: 450,
          column: 23
        },
        end: {
          line: 498,
          column: 6
        }
      },
      "62": {
        start: {
          line: 451,
          column: 37
        },
        end: {
          line: 451,
          column: 41
        }
      },
      "63": {
        start: {
          line: 454,
          column: 6
        },
        end: {
          line: 480,
          column: 7
        }
      },
      "64": {
        start: {
          line: 455,
          column: 8
        },
        end: {
          line: 473,
          column: 9
        }
      },
      "65": {
        start: {
          line: 456,
          column: 10
        },
        end: {
          line: 463,
          column: 14
        }
      },
      "66": {
        start: {
          line: 456,
          column: 58
        },
        end: {
          line: 463,
          column: 11
        }
      },
      "67": {
        start: {
          line: 464,
          column: 15
        },
        end: {
          line: 473,
          column: 9
        }
      },
      "68": {
        start: {
          line: 465,
          column: 10
        },
        end: {
          line: 472,
          column: 14
        }
      },
      "69": {
        start: {
          line: 465,
          column: 52
        },
        end: {
          line: 472,
          column: 11
        }
      },
      "70": {
        start: {
          line: 474,
          column: 8
        },
        end: {
          line: 479,
          column: 10
        }
      },
      "71": {
        start: {
          line: 482,
          column: 6
        },
        end: {
          line: 491,
          column: 7
        }
      },
      "72": {
        start: {
          line: 483,
          column: 8
        },
        end: {
          line: 490,
          column: 12
        }
      },
      "73": {
        start: {
          line: 483,
          column: 48
        },
        end: {
          line: 490,
          column: 9
        }
      },
      "74": {
        start: {
          line: 492,
          column: 6
        },
        end: {
          line: 497,
          column: 8
        }
      },
      "75": {
        start: {
          line: 499,
          column: 4
        },
        end: {
          line: 499,
          column: 46
        }
      },
      "76": {
        start: {
          line: 501,
          column: 19
        },
        end: {
          line: 501,
          column: 31
        }
      },
      "77": {
        start: {
          line: 502,
          column: 4
        },
        end: {
          line: 516,
          column: 5
        }
      },
      "78": {
        start: {
          line: 503,
          column: 6
        },
        end: {
          line: 503,
          column: 39
        }
      },
      "79": {
        start: {
          line: 504,
          column: 6
        },
        end: {
          line: 504,
          column: 31
        }
      },
      "80": {
        start: {
          line: 505,
          column: 11
        },
        end: {
          line: 516,
          column: 5
        }
      },
      "81": {
        start: {
          line: 506,
          column: 6
        },
        end: {
          line: 514,
          column: 9
        }
      },
      "82": {
        start: {
          line: 507,
          column: 8
        },
        end: {
          line: 509,
          column: 9
        }
      },
      "83": {
        start: {
          line: 508,
          column: 10
        },
        end: {
          line: 508,
          column: 19
        }
      },
      "84": {
        start: {
          line: 510,
          column: 8
        },
        end: {
          line: 512,
          column: 9
        }
      },
      "85": {
        start: {
          line: 511,
          column: 10
        },
        end: {
          line: 511,
          column: 20
        }
      },
      "86": {
        start: {
          line: 513,
          column: 8
        },
        end: {
          line: 513,
          column: 67
        }
      },
      "87": {
        start: {
          line: 515,
          column: 6
        },
        end: {
          line: 515,
          column: 31
        }
      },
      "88": {
        start: {
          line: 518,
          column: 30
        },
        end: {
          line: 518,
          column: 57
        }
      },
      "89": {
        start: {
          line: 519,
          column: 25
        },
        end: {
          line: 519,
          column: 99
        }
      },
      "90": {
        start: {
          line: 521,
          column: 34
        },
        end: {
          line: 521,
          column: 64
        }
      },
      "91": {
        start: {
          line: 523,
          column: 4
        },
        end: {
          line: 528,
          column: 6
        }
      },
      "92": {
        start: {
          line: 532,
          column: 4
        },
        end: {
          line: 532,
          column: 17
        }
      },
      "93": {
        start: {
          line: 533,
          column: 4
        },
        end: {
          line: 537,
          column: 6
        }
      },
      "94": {
        start: {
          line: 540,
          column: 23
        },
        end: {
          line: 552,
          column: 3
        }
      },
      "95": {
        start: {
          line: 541,
          column: 4
        },
        end: {
          line: 541,
          column: 23
        }
      },
      "96": {
        start: {
          line: 544,
          column: 26
        },
        end: {
          line: 544,
          column: 65
        }
      },
      "97": {
        start: {
          line: 546,
          column: 4
        },
        end: {
          line: 548,
          column: 5
        }
      },
      "98": {
        start: {
          line: 547,
          column: 6
        },
        end: {
          line: 547,
          column: 52
        }
      },
      "99": {
        start: {
          line: 549,
          column: 4
        },
        end: {
          line: 551,
          column: 8
        }
      },
      "100": {
        start: {
          line: 549,
          column: 41
        },
        end: {
          line: 551,
          column: 5
        }
      },
      "101": {
        start: {
          line: 555,
          column: 98
        },
        end: {
          line: 555,
          column: 108
        }
      },
      "102": {
        start: {
          line: 556,
          column: 23
        },
        end: {
          line: 558,
          column: 7
        }
      },
      "103": {
        start: {
          line: 590,
          column: 8
        },
        end: {
          line: 590,
          column: 18
        }
      },
      "104": {
        start: {
          line: 592,
          column: 22
        },
        end: {
          line: 592,
          column: 59
        }
      },
      "105": {
        start: {
          line: 593,
          column: 27
        },
        end: {
          line: 593,
          column: 46
        }
      },
      "106": {
        start: {
          line: 594,
          column: 25
        },
        end: {
          line: 594,
          column: 42
        }
      },
      "107": {
        start: {
          line: 595,
          column: 34
        },
        end: {
          line: 595,
          column: 61
        }
      },
      "108": {
        start: {
          line: 596,
          column: 32
        },
        end: {
          line: 596,
          column: 63
        }
      },
      "109": {
        start: {
          line: 597,
          column: 23
        },
        end: {
          line: 597,
          column: 36
        }
      },
      "110": {
        start: {
          line: 598,
          column: 25
        },
        end: {
          line: 598,
          column: 41
        }
      },
      "111": {
        start: {
          line: 599,
          column: 25
        },
        end: {
          line: 599,
          column: 41
        }
      },
      "112": {
        start: {
          line: 601,
          column: 6
        },
        end: {
          line: 603,
          column: 21
        }
      },
      "113": {
        start: {
          line: 604,
          column: 23
        },
        end: {
          line: 604,
          column: 81
        }
      },
      "114": {
        start: {
          line: 606,
          column: 26
        },
        end: {
          line: 614,
          column: 5
        }
      },
      "115": {
        start: {
          line: 607,
          column: 6
        },
        end: {
          line: 609,
          column: 7
        }
      },
      "116": {
        start: {
          line: 608,
          column: 8
        },
        end: {
          line: 608,
          column: 15
        }
      },
      "117": {
        start: {
          line: 611,
          column: 6
        },
        end: {
          line: 613,
          column: 10
        }
      },
      "118": {
        start: {
          line: 611,
          column: 27
        },
        end: {
          line: 613,
          column: 7
        }
      },
      "119": {
        start: {
          line: 616,
          column: 4
        },
        end: {
          line: 822,
          column: 6
        }
      },
      "120": {
        start: {
          line: 826,
          column: 0
        },
        end: {
          line: 892,
          column: 2
        }
      },
      "121": {
        start: {
          line: 894,
          column: 0
        },
        end: {
          line: 931,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 9
          }
        },
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        line: 53
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        },
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 73,
            column: 7
          }
        },
        line: 67
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 82,
            column: 12
          },
          end: {
            line: 82,
            column: 13
          }
        },
        loc: {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 94,
            column: 13
          }
        },
        line: 83
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        },
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 163,
            column: 56
          }
        },
        line: 159
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        },
        loc: {
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 179,
            column: 85
          }
        },
        line: 179
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 184,
            column: 21
          },
          end: {
            line: 184,
            column: 22
          }
        },
        loc: {
          start: {
            line: 184,
            column: 30
          },
          end: {
            line: 188,
            column: 1
          }
        },
        line: 184
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 196,
            column: 16
          },
          end: {
            line: 196,
            column: 17
          }
        },
        loc: {
          start: {
            line: 196,
            column: 25
          },
          end: {
            line: 196,
            column: 44
          }
        },
        line: 196
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 235,
            column: 25
          },
          end: {
            line: 235,
            column: 26
          }
        },
        loc: {
          start: {
            line: 235,
            column: 83
          },
          end: {
            line: 247,
            column: 1
          }
        },
        line: 235
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 249,
            column: 23
          },
          end: {
            line: 249,
            column: 24
          }
        },
        loc: {
          start: {
            line: 249,
            column: 35
          },
          end: {
            line: 262,
            column: 1
          }
        },
        line: 249
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 250,
            column: 19
          },
          end: {
            line: 250,
            column: 20
          }
        },
        loc: {
          start: {
            line: 250,
            column: 39
          },
          end: {
            line: 261,
            column: 3
          }
        },
        line: 250
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 256,
            column: 49
          },
          end: {
            line: 256,
            column: 50
          }
        },
        loc: {
          start: {
            line: 256,
            column: 62
          },
          end: {
            line: 259,
            column: 7
          }
        },
        line: 256
      },
      "11": {
        name: "renderItems",
        decl: {
          start: {
            line: 264,
            column: 9
          },
          end: {
            line: 264,
            column: 20
          }
        },
        loc: {
          start: {
            line: 291,
            column: 2
          },
          end: {
            line: 428,
            column: 1
          }
        },
        line: 291
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 292,
            column: 32
          },
          end: {
            line: 292,
            column: 33
          }
        },
        loc: {
          start: {
            line: 292,
            column: 39
          },
          end: {
            line: 295,
            column: 3
          }
        },
        line: 292
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 298,
            column: 19
          },
          end: {
            line: 298,
            column: 20
          }
        },
        loc: {
          start: {
            line: 298,
            column: 45
          },
          end: {
            line: 427,
            column: 3
          }
        },
        line: 298
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 431,
            column: 2
          },
          end: {
            line: 431,
            column: 3
          }
        },
        loc: {
          start: {
            line: 431,
            column: 48
          },
          end: {
            line: 529,
            column: 3
          }
        },
        line: 431
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 445,
            column: 27
          },
          end: {
            line: 445,
            column: 28
          }
        },
        loc: {
          start: {
            line: 445,
            column: 35
          },
          end: {
            line: 445,
            column: 67
          }
        },
        line: 445
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 450,
            column: 33
          },
          end: {
            line: 450,
            column: 34
          }
        },
        loc: {
          start: {
            line: 450,
            column: 41
          },
          end: {
            line: 498,
            column: 5
          }
        },
        line: 450
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 456,
            column: 42
          },
          end: {
            line: 456,
            column: 43
          }
        },
        loc: {
          start: {
            line: 456,
            column: 58
          },
          end: {
            line: 463,
            column: 11
          }
        },
        line: 456
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 465,
            column: 39
          },
          end: {
            line: 465,
            column: 40
          }
        },
        loc: {
          start: {
            line: 465,
            column: 52
          },
          end: {
            line: 472,
            column: 11
          }
        },
        line: 465
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 483,
            column: 36
          },
          end: {
            line: 483,
            column: 37
          }
        },
        loc: {
          start: {
            line: 483,
            column: 48
          },
          end: {
            line: 490,
            column: 9
          }
        },
        line: 483
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 506,
            column: 31
          },
          end: {
            line: 506,
            column: 32
          }
        },
        loc: {
          start: {
            line: 506,
            column: 41
          },
          end: {
            line: 514,
            column: 7
          }
        },
        line: 506
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 531,
            column: 2
          },
          end: {
            line: 531,
            column: 3
          }
        },
        loc: {
          start: {
            line: 531,
            column: 21
          },
          end: {
            line: 538,
            column: 3
          }
        },
        line: 531
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 540,
            column: 23
          },
          end: {
            line: 540,
            column: 24
          }
        },
        loc: {
          start: {
            line: 540,
            column: 28
          },
          end: {
            line: 552,
            column: 3
          }
        },
        line: 540
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 549,
            column: 18
          },
          end: {
            line: 549,
            column: 19
          }
        },
        loc: {
          start: {
            line: 549,
            column: 41
          },
          end: {
            line: 551,
            column: 5
          }
        },
        line: 549
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 554,
            column: 2
          },
          end: {
            line: 554,
            column: 3
          }
        },
        loc: {
          start: {
            line: 554,
            column: 11
          },
          end: {
            line: 823,
            column: 3
          }
        },
        line: 554
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 606,
            column: 26
          },
          end: {
            line: 606,
            column: 27
          }
        },
        loc: {
          start: {
            line: 606,
            column: 39
          },
          end: {
            line: 614,
            column: 5
          }
        },
        line: 606
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 611,
            column: 20
          },
          end: {
            line: 611,
            column: 21
          }
        },
        loc: {
          start: {
            line: 611,
            column: 27
          },
          end: {
            line: 613,
            column: 7
          }
        },
        line: 611
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 29
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }],
        line: 53
      },
      "1": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 73,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 29
          }
        }, {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 73,
            column: 7
          }
        }],
        line: 67
      },
      "2": {
        loc: {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 94,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 83,
            column: 53
          }
        }, {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 94,
            column: 13
          }
        }],
        line: 83
      },
      "3": {
        loc: {
          start: {
            line: 99,
            column: 10
          },
          end: {
            line: 104,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 10
          },
          end: {
            line: 99,
            column: 19
          }
        }, {
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 104,
            column: 11
          }
        }],
        line: 99
      },
      "4": {
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 163,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 13
          }
        }, {
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 160,
            column: 19
          }
        }, {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 161,
            column: 27
          }
        }, {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 162,
            column: 42
          }
        }, {
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 56
          }
        }],
        line: 159
      },
      "5": {
        loc: {
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 179,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 179,
            column: 38
          }
        }, {
          start: {
            line: 179,
            column: 42
          },
          end: {
            line: 179,
            column: 85
          }
        }],
        line: 179
      },
      "6": {
        loc: {
          start: {
            line: 185,
            column: 21
          },
          end: {
            line: 185,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 185,
            column: 21
          },
          end: {
            line: 185,
            column: 32
          }
        }, {
          start: {
            line: 185,
            column: 36
          },
          end: {
            line: 185,
            column: 55
          }
        }, {
          start: {
            line: 185,
            column: 59
          },
          end: {
            line: 185,
            column: 94
          }
        }],
        line: 185
      },
      "7": {
        loc: {
          start: {
            line: 187,
            column: 9
          },
          end: {
            line: 187,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 9
          },
          end: {
            line: 187,
            column: 19
          }
        }, {
          start: {
            line: 187,
            column: 23
          },
          end: {
            line: 187,
            column: 35
          }
        }],
        line: 187
      },
      "8": {
        loc: {
          start: {
            line: 238,
            column: 2
          },
          end: {
            line: 240,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 238,
            column: 2
          },
          end: {
            line: 240,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 238
      },
      "9": {
        loc: {
          start: {
            line: 242,
            column: 2
          },
          end: {
            line: 244,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 242,
            column: 2
          },
          end: {
            line: 244,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 242
      },
      "10": {
        loc: {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 251
      },
      "11": {
        loc: {
          start: {
            line: 255,
            column: 4
          },
          end: {
            line: 260,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 255,
            column: 4
          },
          end: {
            line: 260,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 255
      },
      "12": {
        loc: {
          start: {
            line: 293,
            column: 20
          },
          end: {
            line: 293,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 293,
            column: 38
          },
          end: {
            line: 293,
            column: 64
          }
        }, {
          start: {
            line: 293,
            column: 67
          },
          end: {
            line: 293,
            column: 93
          }
        }],
        line: 293
      },
      "13": {
        loc: {
          start: {
            line: 294,
            column: 43
          },
          end: {
            line: 294,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 294,
            column: 70
          },
          end: {
            line: 294,
            column: 71
          }
        }, {
          start: {
            line: 294,
            column: 74
          },
          end: {
            line: 294,
            column: 81
          }
        }],
        line: 294
      },
      "14": {
        loc: {
          start: {
            line: 305,
            column: 25
          },
          end: {
            line: 305,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 305,
            column: 25
          },
          end: {
            line: 305,
            column: 45
          }
        }, {
          start: {
            line: 305,
            column: 49
          },
          end: {
            line: 305,
            column: 81
          }
        }],
        line: 305
      },
      "15": {
        loc: {
          start: {
            line: 306,
            column: 30
          },
          end: {
            line: 306,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 306,
            column: 30
          },
          end: {
            line: 306,
            column: 45
          }
        }, {
          start: {
            line: 306,
            column: 49
          },
          end: {
            line: 306,
            column: 62
          }
        }],
        line: 306
      },
      "16": {
        loc: {
          start: {
            line: 307,
            column: 27
          },
          end: {
            line: 307,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 307,
            column: 27
          },
          end: {
            line: 307,
            column: 43
          }
        }, {
          start: {
            line: 307,
            column: 48
          },
          end: {
            line: 307,
            column: 63
          }
        }, {
          start: {
            line: 307,
            column: 67
          },
          end: {
            line: 307,
            column: 79
          }
        }],
        line: 307
      },
      "17": {
        loc: {
          start: {
            line: 310,
            column: 6
          },
          end: {
            line: 320,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 311,
            column: 10
          },
          end: {
            line: 311,
            column: 43
          }
        }, {
          start: {
            line: 312,
            column: 10
          },
          end: {
            line: 320,
            column: 11
          }
        }],
        line: 310
      },
      "18": {
        loc: {
          start: {
            line: 324,
            column: 6
          },
          end: {
            line: 324,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 324,
            column: 6
          },
          end: {
            line: 324,
            column: 39
          }
        }, {
          start: {
            line: 324,
            column: 43
          },
          end: {
            line: 324,
            column: 89
          }
        }],
        line: 324
      },
      "19": {
        loc: {
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 326,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 326,
            column: 22
          }
        }, {
          start: {
            line: 326,
            column: 27
          },
          end: {
            line: 326,
            column: 64
          }
        }, {
          start: {
            line: 326,
            column: 68
          },
          end: {
            line: 326,
            column: 87
          }
        }],
        line: 326
      },
      "20": {
        loc: {
          start: {
            line: 327,
            column: 24
          },
          end: {
            line: 327,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 327,
            column: 24
          },
          end: {
            line: 327,
            column: 48
          }
        }, {
          start: {
            line: 327,
            column: 52
          },
          end: {
            line: 327,
            column: 80
          }
        }],
        line: 327
      },
      "21": {
        loc: {
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 329,
            column: 31
          },
          end: {
            line: 329,
            column: 59
          }
        }, {
          start: {
            line: 329,
            column: 62
          },
          end: {
            line: 329,
            column: 89
          }
        }],
        line: 329
      },
      "22": {
        loc: {
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 13
          }
        }, {
          start: {
            line: 329,
            column: 17
          },
          end: {
            line: 329,
            column: 28
          }
        }],
        line: 329
      },
      "23": {
        loc: {
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 330
      },
      "24": {
        loc: {
          start: {
            line: 330,
            column: 8
          },
          end: {
            line: 330,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 330,
            column: 8
          },
          end: {
            line: 330,
            column: 24
          }
        }, {
          start: {
            line: 330,
            column: 28
          },
          end: {
            line: 330,
            column: 56
          }
        }],
        line: 330
      },
      "25": {
        loc: {
          start: {
            line: 337,
            column: 29
          },
          end: {
            line: 337,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 337,
            column: 29
          },
          end: {
            line: 337,
            column: 46
          }
        }, {
          start: {
            line: 337,
            column: 50
          },
          end: {
            line: 337,
            column: 64
          }
        }],
        line: 337
      },
      "26": {
        loc: {
          start: {
            line: 352,
            column: 24
          },
          end: {
            line: 352,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 352,
            column: 24
          },
          end: {
            line: 352,
            column: 61
          }
        }, {
          start: {
            line: 352,
            column: 65
          },
          end: {
            line: 352,
            column: 98
          }
        }],
        line: 352
      },
      "27": {
        loc: {
          start: {
            line: 354,
            column: 11
          },
          end: {
            line: 354,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 354,
            column: 11
          },
          end: {
            line: 354,
            column: 22
          }
        }, {
          start: {
            line: 354,
            column: 26
          },
          end: {
            line: 354,
            column: 37
          }
        }],
        line: 354
      },
      "28": {
        loc: {
          start: {
            line: 359,
            column: 4
          },
          end: {
            line: 381,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 359,
            column: 4
          },
          end: {
            line: 381,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 359
      },
      "29": {
        loc: {
          start: {
            line: 366,
            column: 29
          },
          end: {
            line: 366,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 366,
            column: 29
          },
          end: {
            line: 366,
            column: 46
          }
        }, {
          start: {
            line: 366,
            column: 50
          },
          end: {
            line: 366,
            column: 64
          }
        }],
        line: 366
      },
      "30": {
        loc: {
          start: {
            line: 378,
            column: 11
          },
          end: {
            line: 378,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 378,
            column: 11
          },
          end: {
            line: 378,
            column: 22
          }
        }, {
          start: {
            line: 378,
            column: 26
          },
          end: {
            line: 378,
            column: 37
          }
        }],
        line: 378
      },
      "31": {
        loc: {
          start: {
            line: 385,
            column: 23
          },
          end: {
            line: 385,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 385,
            column: 23
          },
          end: {
            line: 385,
            column: 39
          }
        }, {
          start: {
            line: 385,
            column: 43
          },
          end: {
            line: 385,
            column: 75
          }
        }],
        line: 385
      },
      "32": {
        loc: {
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 392,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 392,
            column: 54
          },
          end: {
            line: 392,
            column: 58
          }
        }, {
          start: {
            line: 392,
            column: 61
          },
          end: {
            line: 392,
            column: 94
          }
        }],
        line: 392
      },
      "33": {
        loc: {
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 392,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 392,
            column: 23
          }
        }, {
          start: {
            line: 392,
            column: 27
          },
          end: {
            line: 392,
            column: 51
          }
        }],
        line: 392
      },
      "34": {
        loc: {
          start: {
            line: 398,
            column: 27
          },
          end: {
            line: 398,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 398,
            column: 27
          },
          end: {
            line: 398,
            column: 44
          }
        }, {
          start: {
            line: 398,
            column: 48
          },
          end: {
            line: 398,
            column: 62
          }
        }],
        line: 398
      },
      "35": {
        loc: {
          start: {
            line: 421,
            column: 22
          },
          end: {
            line: 421,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 421,
            column: 22
          },
          end: {
            line: 421,
            column: 59
          }
        }, {
          start: {
            line: 421,
            column: 63
          },
          end: {
            line: 421,
            column: 96
          }
        }],
        line: 421
      },
      "36": {
        loc: {
          start: {
            line: 444,
            column: 4
          },
          end: {
            line: 446,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 444,
            column: 4
          },
          end: {
            line: 446,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 444
      },
      "37": {
        loc: {
          start: {
            line: 454,
            column: 6
          },
          end: {
            line: 480,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 454,
            column: 6
          },
          end: {
            line: 480,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 454
      },
      "38": {
        loc: {
          start: {
            line: 455,
            column: 8
          },
          end: {
            line: 473,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 455,
            column: 8
          },
          end: {
            line: 473,
            column: 9
          }
        }, {
          start: {
            line: 464,
            column: 15
          },
          end: {
            line: 473,
            column: 9
          }
        }],
        line: 455
      },
      "39": {
        loc: {
          start: {
            line: 455,
            column: 12
          },
          end: {
            line: 455,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 455,
            column: 12
          },
          end: {
            line: 455,
            column: 32
          }
        }, {
          start: {
            line: 455,
            column: 36
          },
          end: {
            line: 455,
            column: 67
          }
        }],
        line: 455
      },
      "40": {
        loc: {
          start: {
            line: 464,
            column: 15
          },
          end: {
            line: 473,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 464,
            column: 15
          },
          end: {
            line: 473,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 464
      },
      "41": {
        loc: {
          start: {
            line: 464,
            column: 19
          },
          end: {
            line: 464,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 464,
            column: 19
          },
          end: {
            line: 464,
            column: 36
          }
        }, {
          start: {
            line: 464,
            column: 40
          },
          end: {
            line: 464,
            column: 68
          }
        }],
        line: 464
      },
      "42": {
        loc: {
          start: {
            line: 482,
            column: 6
          },
          end: {
            line: 491,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 482,
            column: 6
          },
          end: {
            line: 491,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 482
      },
      "43": {
        loc: {
          start: {
            line: 482,
            column: 10
          },
          end: {
            line: 482,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 482,
            column: 10
          },
          end: {
            line: 482,
            column: 26
          }
        }, {
          start: {
            line: 482,
            column: 30
          },
          end: {
            line: 482,
            column: 57
          }
        }],
        line: 482
      },
      "44": {
        loc: {
          start: {
            line: 502,
            column: 4
          },
          end: {
            line: 516,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 502,
            column: 4
          },
          end: {
            line: 516,
            column: 5
          }
        }, {
          start: {
            line: 505,
            column: 11
          },
          end: {
            line: 516,
            column: 5
          }
        }],
        line: 502
      },
      "45": {
        loc: {
          start: {
            line: 505,
            column: 11
          },
          end: {
            line: 516,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 505,
            column: 11
          },
          end: {
            line: 516,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 505
      },
      "46": {
        loc: {
          start: {
            line: 507,
            column: 8
          },
          end: {
            line: 509,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 507,
            column: 8
          },
          end: {
            line: 509,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 507
      },
      "47": {
        loc: {
          start: {
            line: 510,
            column: 8
          },
          end: {
            line: 512,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 510,
            column: 8
          },
          end: {
            line: 512,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 510
      },
      "48": {
        loc: {
          start: {
            line: 519,
            column: 25
          },
          end: {
            line: 519,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 519,
            column: 45
          },
          end: {
            line: 519,
            column: 81
          }
        }, {
          start: {
            line: 519,
            column: 84
          },
          end: {
            line: 519,
            column: 99
          }
        }],
        line: 519
      },
      "49": {
        loc: {
          start: {
            line: 519,
            column: 45
          },
          end: {
            line: 519,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 519,
            column: 45
          },
          end: {
            line: 519,
            column: 63
          }
        }, {
          start: {
            line: 519,
            column: 67
          },
          end: {
            line: 519,
            column: 81
          }
        }],
        line: 519
      },
      "50": {
        loc: {
          start: {
            line: 546,
            column: 4
          },
          end: {
            line: 548,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 546,
            column: 4
          },
          end: {
            line: 548,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 546
      },
      "51": {
        loc: {
          start: {
            line: 601,
            column: 6
          },
          end: {
            line: 603,
            column: 21
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 602,
            column: 10
          },
          end: {
            line: 602,
            column: 18
          }
        }, {
          start: {
            line: 603,
            column: 10
          },
          end: {
            line: 603,
            column: 21
          }
        }],
        line: 601
      },
      "52": {
        loc: {
          start: {
            line: 601,
            column: 6
          },
          end: {
            line: 601,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 601,
            column: 6
          },
          end: {
            line: 601,
            column: 28
          }
        }, {
          start: {
            line: 601,
            column: 33
          },
          end: {
            line: 601,
            column: 55
          }
        }, {
          start: {
            line: 601,
            column: 59
          },
          end: {
            line: 601,
            column: 81
          }
        }],
        line: 601
      },
      "53": {
        loc: {
          start: {
            line: 604,
            column: 23
          },
          end: {
            line: 604,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 604,
            column: 23
          },
          end: {
            line: 604,
            column: 38
          }
        }, {
          start: {
            line: 604,
            column: 42
          },
          end: {
            line: 604,
            column: 55
          }
        }, {
          start: {
            line: 604,
            column: 59
          },
          end: {
            line: 604,
            column: 81
          }
        }],
        line: 604
      },
      "54": {
        loc: {
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 607
      },
      "55": {
        loc: {
          start: {
            line: 627,
            column: 25
          },
          end: {
            line: 627,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 627,
            column: 25
          },
          end: {
            line: 627,
            column: 35
          }
        }, {
          start: {
            line: 627,
            column: 39
          },
          end: {
            line: 627,
            column: 65
          }
        }],
        line: 627
      },
      "56": {
        loc: {
          start: {
            line: 628,
            column: 9
          },
          end: {
            line: 664,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 628,
            column: 9
          },
          end: {
            line: 628,
            column: 23
          }
        }, {
          start: {
            line: 629,
            column: 10
          },
          end: {
            line: 629,
            column: 29
          }
        }, {
          start: {
            line: 630,
            column: 12
          },
          end: {
            line: 663,
            column: 33
          }
        }],
        line: 628
      },
      "57": {
        loc: {
          start: {
            line: 665,
            column: 9
          },
          end: {
            line: 695,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 665,
            column: 9
          },
          end: {
            line: 665,
            column: 23
          }
        }, {
          start: {
            line: 666,
            column: 10
          },
          end: {
            line: 666,
            column: 29
          }
        }, {
          start: {
            line: 667,
            column: 10
          },
          end: {
            line: 695,
            column: 11
          }
        }],
        line: 665
      },
      "58": {
        loc: {
          start: {
            line: 696,
            column: 9
          },
          end: {
            line: 734,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 696,
            column: 9
          },
          end: {
            line: 696,
            column: 21
          }
        }, {
          start: {
            line: 697,
            column: 10
          },
          end: {
            line: 733,
            column: 31
          }
        }],
        line: 696
      },
      "59": {
        loc: {
          start: {
            line: 698,
            column: 25
          },
          end: {
            line: 698,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 698,
            column: 50
          },
          end: {
            line: 698,
            column: 76
          }
        }, {
          start: {
            line: 698,
            column: 79
          },
          end: {
            line: 698,
            column: 80
          }
        }],
        line: 698
      },
      "60": {
        loc: {
          start: {
            line: 735,
            column: 9
          },
          end: {
            line: 772,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 735,
            column: 9
          },
          end: {
            line: 735,
            column: 19
          }
        }, {
          start: {
            line: 736,
            column: 11
          },
          end: {
            line: 772,
            column: 11
          }
        }],
        line: 735
      },
      "61": {
        loc: {
          start: {
            line: 736,
            column: 11
          },
          end: {
            line: 772,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 737,
            column: 12
          },
          end: {
            line: 739,
            column: 31
          }
        }, {
          start: {
            line: 741,
            column: 12
          },
          end: {
            line: 771,
            column: 13
          }
        }],
        line: 736
      },
      "62": {
        loc: {
          start: {
            line: 736,
            column: 11
          },
          end: {
            line: 736,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 736,
            column: 11
          },
          end: {
            line: 736,
            column: 19
          }
        }, {
          start: {
            line: 736,
            column: 23
          },
          end: {
            line: 736,
            column: 44
          }
        }],
        line: 736
      },
      "63": {
        loc: {
          start: {
            line: 773,
            column: 9
          },
          end: {
            line: 820,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 773,
            column: 9
          },
          end: {
            line: 773,
            column: 30
          }
        }, {
          start: {
            line: 774,
            column: 11
          },
          end: {
            line: 820,
            column: 11
          }
        }],
        line: 773
      },
      "64": {
        loc: {
          start: {
            line: 774,
            column: 11
          },
          end: {
            line: 820,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 775,
            column: 12
          },
          end: {
            line: 777,
            column: 31
          }
        }, {
          start: {
            line: 779,
            column: 12
          },
          end: {
            line: 819,
            column: 28
          }
        }],
        line: 774
      },
      "65": {
        loc: {
          start: {
            line: 774,
            column: 11
          },
          end: {
            line: 774,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 774,
            column: 11
          },
          end: {
            line: 774,
            column: 19
          }
        }, {
          start: {
            line: 774,
            column: 23
          },
          end: {
            line: 774,
            column: 44
          }
        }],
        line: 774
      },
      "66": {
        loc: {
          start: {
            line: 782,
            column: 16
          },
          end: {
            line: 782,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 782,
            column: 37
          },
          end: {
            line: 782,
            column: 45
          }
        }, {
          start: {
            line: 782,
            column: 48
          },
          end: {
            line: 782,
            column: 76
          }
        }],
        line: 782
      },
      "67": {
        loc: {
          start: {
            line: 810,
            column: 15
          },
          end: {
            line: 818,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 810,
            column: 15
          },
          end: {
            line: 810,
            column: 34
          }
        }, {
          start: {
            line: 811,
            column: 16
          },
          end: {
            line: 811,
            column: 37
          }
        }, {
          start: {
            line: 812,
            column: 18
          },
          end: {
            line: 817,
            column: 28
          }
        }],
        line: 810
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0, 0],
      "53": [0, 0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0, 0],
      "57": [0, 0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a0a57b96ec75561c8fd25ac14649f137723a6eb3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1p1ey67r80 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1p1ey67r80();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_1p1ey67r80().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-SectionCluster'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-wrap: wrap;\n      position: relative;\n\n      ", ";\n    "])), function (props) {
  cov_1p1ey67r80().f[0]++;
  cov_1p1ey67r80().s[1]++;
  return (cov_1p1ey67r80().b[0][0]++, props.isReportContext) && (cov_1p1ey67r80().b[0][1]++, "\n          width: 100%;\n          .stx-ProductBox {\n            padding-left: 0;\n          }\n        ");
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-wrap: wrap;\n      position: relative;\n\n      ", ";\n\n      &.showAsGrid {\n        gap: ", "px;\n\n        .stx-ProductBox {\n          display: flex;\n          margin-left: 0;\n\n          ", ";\n        }\n      }\n\n      &.showAsCarousel {\n        ", ";\n        .stx-ProductCard {\n          background: transparent;\n        }\n        .stx-ProductBox {\n          &:hover {\n            box-shadow: none;\n\n            .stx-ProductCard {\n              background: initial;\n            }\n          }\n        }\n      }\n\n      &.showAsCarousel,\n      &.showAsSlider {\n        .stx-ProductBox {\n          display: inline-flex;\n          height: 100%;\n        }\n      }\n      .stx-ProductBox .stx-ProductActions .g-Button.g-Button-primary .g-Icon.g-Icon-more {\n        color: var(--primaryTextColor);\n      }\n    "])), function (props) {
  cov_1p1ey67r80().f[1]++;
  cov_1p1ey67r80().s[2]++;
  return (cov_1p1ey67r80().b[1][0]++, props.isReportContext) && (cov_1p1ey67r80().b[1][1]++, "\n        width: 100%;\n        .stx-ProductBox {\n          padding-left: 0;\n        }\n      ");
}, _themeMapper.evolutionTheme.spacings.lg, function (_ref) {
  var columns = _ref.columns,
    fullWidthActionButtonBreakpoint = _ref.fullWidthActionButtonBreakpoint;
  cov_1p1ey67r80().f[2]++;
  cov_1p1ey67r80().s[3]++;
  return (cov_1p1ey67r80().b[2][0]++, columns > fullWidthActionButtonBreakpoint) && (cov_1p1ey67r80().b[2][1]++, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n              > .stx-ProductCard {\n                > .stx-ProductActions {\n                  > .stx-ProductActions-BoxWrapper {\n                    max-width: none;\n                    width: 100%;\n                    flex: 1 1 auto;\n                  }\n                }\n              }\n            "]))));
}, (cov_1p1ey67r80().b[3][0]++, _reactDeviceDetect.isDesktop) && (cov_1p1ey67r80().b[3][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n            .stx-ProductBox {\n              margin-left: 0;\n            }\n          "]))))))));
var FullWidthFlex = (cov_1p1ey67r80().s[4]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_grid.Flex), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    flex-direction: column;\n    width: 100%;\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    flex-direction: column;\n    width: 100%;\n    gap: ", "px;\n  "])), _themeMapper.evolutionTheme.spacings.lg))));
var FullWidthFilmStrip = (cov_1p1ey67r80().s[5]++, (0, _styledComponents.default)(_filmStrip.default)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"]))));
var ProductLineWrapper = (cov_1p1ey67r80().s[6]++, _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)([""]))));
var ProductBox = (cov_1p1ey67r80().s[7]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_grid.Box).attrs({
  className: 'stx-ProductBox'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-block;\n      flex-direction: column;\n      padding: 0 1rem;\n      vertical-align: top;\n      ", ";\n    "])), function (props) {
  cov_1p1ey67r80().f[3]++;
  cov_1p1ey67r80().s[8]++;
  return (cov_1p1ey67r80().b[4][0]++, props) && (cov_1p1ey67r80().b[4][1]++, props.theme) && (cov_1p1ey67r80().b[4][2]++, props.theme.section) && (cov_1p1ey67r80().b[4][3]++, props.theme.section.productPadding) && (cov_1p1ey67r80().b[4][4]++, "padding:".concat(props.theme.section.productPadding, ";"));
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-block;\n      flex-direction: column;\n      vertical-align: top;\n\n      &:hover {\n        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);\n        border-radius: var(--generalBorderRadius, 12px);\n        .stx-ProductCard {\n          background: var(--hoverBgColor, #F2F2F2);\n        }\n      }\n\n      ", ";\n    "])), function (_ref2) {
  var _theme$section;
  var theme = _ref2.theme;
  cov_1p1ey67r80().f[4]++;
  cov_1p1ey67r80().s[9]++;
  return (cov_1p1ey67r80().b[5][0]++, theme === null || theme === void 0 || (_theme$section = theme.section) === null || _theme$section === void 0 ? void 0 : _theme$section.productPadding) && (cov_1p1ey67r80().b[5][1]++, "padding: ".concat(theme.section.productPadding, ";"));
})), {
  useForwardRef: true
}));
cov_1p1ey67r80().s[10]++;
var dividerColor = function dividerColor(props) {
  cov_1p1ey67r80().f[5]++;
  var themeColor = (cov_1p1ey67r80().s[11]++, (cov_1p1ey67r80().b[6][0]++, props.theme) && (cov_1p1ey67r80().b[6][1]++, props.theme.section) && (cov_1p1ey67r80().b[6][2]++, props.theme.section.backgroundColor));
  var defaultColor = (cov_1p1ey67r80().s[12]++, _stylingConstants.default.color.disabledBackground);
  cov_1p1ey67r80().s[13]++;
  return (cov_1p1ey67r80().b[7][0]++, themeColor) || (cov_1p1ey67r80().b[7][1]++, defaultColor);
};
var Divider = (cov_1p1ey67r80().s[14]++, _styledComponents.default.hr.attrs({
  className: 'g-Divider',
  role: 'presentation'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  border: 0;\n  margin: 0;\n  height: 1px;\n  background: ", ";\n"])), function (props) {
  cov_1p1ey67r80().f[6]++;
  cov_1p1ey67r80().s[15]++;
  return dividerColor(props);
}));
var MoreBox = (cov_1p1ey67r80().s[16]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_grid.Box).attrs({
  className: 'stx-SectionCluster-ShowMoreButton'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n      margin-left: auto;\n      margin-right: auto;\n      text-align: center;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: center;\n      margin-left: 0;\n      margin-right: 0;\n\n      > button {\n        width: 100%;\n      }\n\n      ", ";\n    "])), _utils.gMediaQueries.md(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n        margin-left: auto;\n\n        > button {\n          width: auto;\n        }\n      "])))))));
var NoResultsWrapper = (cov_1p1ey67r80().s[17]++, _styledComponents.default.div.attrs({
  className: 'stx-SectionCluster-noResultsContainer'
})(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 1rem;\n"]))));
cov_1p1ey67r80().s[18]++;
var generateUniqueId = function generateUniqueId(_ref3) {
  var keyPrefix = _ref3.keyPrefix,
    product = _ref3.product,
    performance = _ref3.performance,
    timeslot = _ref3.timeslot,
    index = _ref3.index;
  cov_1p1ey67r80().f[7]++;
  var idArr = (cov_1p1ey67r80().s[19]++, [keyPrefix, index, product.id]);
  cov_1p1ey67r80().s[20]++;
  if (performance) {
    cov_1p1ey67r80().b[8][0]++;
    cov_1p1ey67r80().s[21]++;
    idArr.push(performance.id);
  } else {
    cov_1p1ey67r80().b[8][1]++;
  }
  cov_1p1ey67r80().s[22]++;
  if (timeslot) {
    cov_1p1ey67r80().b[9][0]++;
    cov_1p1ey67r80().s[23]++;
    idArr.push(timeslot.id);
  } else {
    cov_1p1ey67r80().b[9][1]++;
  }
  cov_1p1ey67r80().s[24]++;
  return idArr.join('-');
};
cov_1p1ey67r80().s[25]++;
var updatePosition = function updatePosition(products) {
  cov_1p1ey67r80().f[8]++;
  cov_1p1ey67r80().s[26]++;
  products.forEach(function (product, index) {
    cov_1p1ey67r80().f[9]++;
    cov_1p1ey67r80().s[27]++;
    if (product.product.productDataLayer) {
      cov_1p1ey67r80().b[10][0]++;
      cov_1p1ey67r80().s[28]++;
      // eslint-disable-next-line no-param-reassign
      product.product.productDataLayer.position = index;
    } else {
      cov_1p1ey67r80().b[10][1]++;
    }
    cov_1p1ey67r80().s[29]++;
    if ((0, _size.default)(product.product.advantageDataLayer) > 0) {
      cov_1p1ey67r80().b[11][0]++;
      cov_1p1ey67r80().s[30]++;
      product.product.advantageDataLayer.forEach(function (advantage) {
        cov_1p1ey67r80().f[10]++;
        cov_1p1ey67r80().s[31]++;
        // eslint-disable-next-line no-param-reassign
        advantage.position = index;
      });
    } else {
      cov_1p1ey67r80().b[11][1]++;
    }
  });
};
function renderItems(keyPrefix, items, columns, aspectRatio, layout, showOccurrences, waitingListEnabled, showDescription, showPrice, displayActionBtn, currencyCode, isSignedIn, showDate, showTime, classifyBy, onActionClick, reportData, isLandingPage, onWatchStreamOnline, ecommerceGoogleTracking, replaceProductNameByPerformance, resaleAvailability, _ref4, actionButtonVariant, isShownChevron, showAsGrid) {
  var _this = this;
  var currentTheme = _ref4.currentTheme,
    themeQueries = _ref4.themeQueries;
  cov_1p1ey67r80().f[11]++;
  cov_1p1ey67r80().s[32]++;
  var getBoxResponsiveWidth = function getBoxResponsiveWidth(col) {
    cov_1p1ey67r80().f[12]++;
    var spacing = (cov_1p1ey67r80().s[33]++, !isShownChevron ? (cov_1p1ey67r80().b[12][0]++, _themeMapper.evolutionTheme.spacings.xl) : (cov_1p1ey67r80().b[12][1]++, _themeMapper.evolutionTheme.spacings.lg));
    cov_1p1ey67r80().s[34]++;
    return (0, _helper.getGridItemResponsiveWidth)(col, themeQueries.EQUILIBRIUM ? (cov_1p1ey67r80().b[13][0]++, 0) : (cov_1p1ey67r80().b[13][1]++, spacing));
  };

  // items is the object that contains the product and, if display as perf, performance and timeslot
  cov_1p1ey67r80().s[35]++;
  return items.map(function (item, index, itemArr) {
    cov_1p1ey67r80().f[13]++;
    var _ref5 = (cov_1p1ey67r80().s[36]++, item),
      product = _ref5.product,
      performance = _ref5.performance,
      timeslot = _ref5.timeslot,
      hospitalitySession = _ref5.hospitalitySession;
    var id = (cov_1p1ey67r80().s[37]++, generateUniqueId({
      keyPrefix: keyPrefix,
      product: product,
      performance: performance,
      timeslot: timeslot,
      index: index
    }));
    // if no occurences, do not show the occurences button
    var hasOccurrences = (cov_1p1ey67r80().s[38]++, _product2.ProductModel.getOccurrences(product).length > 0);

    // in case in day display and this is a perf, show action instead of occurrences
    var onePerfInDay = (cov_1p1ey67r80().s[39]++, (cov_1p1ey67r80().b[14][0]++, classifyBy === 'DAY') && (cov_1p1ey67r80().b[14][1]++, item.displayAs === 'PERFORMANCE'));
    var displayOccurences = (cov_1p1ey67r80().s[40]++, (cov_1p1ey67r80().b[15][0]++, showOccurrences) && (cov_1p1ey67r80().b[15][1]++, !onePerfInDay));
    var displayActions = (cov_1p1ey67r80().s[41]++, (cov_1p1ey67r80().b[16][0]++, displayActionBtn) || (cov_1p1ey67r80().b[16][1]++, showOccurrences) && (cov_1p1ey67r80().b[16][2]++, onePerfInDay));
    var gridSettings = (cov_1p1ey67r80().s[42]++, layout === 'SLIDER' ? (cov_1p1ey67r80().b[17][0]++, {
      key: "g-Grid-".concat(id),
      width: 1
    }) : (cov_1p1ey67r80().b[17][1]++, {
      key: "g-Grid-".concat(id),
      width: [1, 1, getBoxResponsiveWidth((0, _helper.getMaxRenderColumns)(columns, 'md', currentTheme)), getBoxResponsiveWidth(columns)]
    }));
    var usingProductLine = (cov_1p1ey67r80().s[43]++, layout === 'PAGINATED_LIST');
    var isHospitalityBundle = (cov_1p1ey67r80().s[44]++, (cov_1p1ey67r80().b[18][0]++, product.productType === 'PACKAGE') && (cov_1p1ey67r80().b[18][1]++, product.productFamily === 'HOSPITALITY_BUNDLE'));
    var usingHospitalityProductLine = (cov_1p1ey67r80().s[45]++, (cov_1p1ey67r80().b[19][0]++, usingProductLine) && ((cov_1p1ey67r80().b[19][1]++, product.productType === 'HOSPITALITY') || (cov_1p1ey67r80().b[19][2]++, isHospitalityBundle)));
    var withDivider = (cov_1p1ey67r80().s[46]++, (cov_1p1ey67r80().b[20][0]++, themeQueries.EQUILIBRIUM) && (cov_1p1ey67r80().b[20][1]++, index !== itemArr.length - 1));
    var productTitleFontSize = (cov_1p1ey67r80().s[47]++, (cov_1p1ey67r80().b[22][0]++, columns) && (cov_1p1ey67r80().b[22][1]++, columns > 4) ? (cov_1p1ey67r80().b[21][0]++, _stylingConstants.default.font.sizeMS) : (cov_1p1ey67r80().b[21][1]++, _stylingConstants.default.font.sizeL));
    cov_1p1ey67r80().s[48]++;
    if ((cov_1p1ey67r80().b[24][0]++, usingProductLine) && (cov_1p1ey67r80().b[24][1]++, !usingHospitalityProductLine)) {
      cov_1p1ey67r80().b[23][0]++;
      cov_1p1ey67r80().s[49]++;
      return /*#__PURE__*/_react.default.createElement(ProductLineWrapper, {
        key: id,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 332,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_product.ProductLine, {
        product: product,
        performance: performance,
        timeslot: timeslot,
        showOccurrences: (cov_1p1ey67r80().b[25][0]++, displayOccurences) && (cov_1p1ey67r80().b[25][1]++, hasOccurrences),
        showActions: displayActions,
        waitingListEnabled: waitingListEnabled,
        showDescription: showDescription,
        showPrice: showPrice,
        currencyCode: currencyCode,
        displayAs: item.displayAs,
        isSignedIn: isSignedIn,
        onActionClick: onActionClick,
        isLandingPage: isLandingPage,
        onWatchStreamOnline: onWatchStreamOnline,
        replaceProductNameByPerformance: replaceProductNameByPerformance,
        ecommerceGoogleTracking: ecommerceGoogleTracking,
        keyPrefix: keyPrefix,
        resaleAvailability: resaleAvailability,
        lastItemId: (cov_1p1ey67r80().b[26][0]++, items[items.length - 1].performanceId) || (cov_1p1ey67r80().b[26][1]++, items[items.length - 1].productId),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 333,
          columnNumber: 11
        }
      }), (cov_1p1ey67r80().b[27][0]++, withDivider) && (cov_1p1ey67r80().b[27][1]++, /*#__PURE__*/_react.default.createElement(Divider, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 354,
          columnNumber: 27
        }
      })));
    } else {
      cov_1p1ey67r80().b[23][1]++;
    }
    cov_1p1ey67r80().s[50]++;
    if (usingHospitalityProductLine) {
      cov_1p1ey67r80().b[28][0]++;
      cov_1p1ey67r80().s[51]++;
      return /*#__PURE__*/_react.default.createElement(ProductLineWrapper, {
        key: id,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 361,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_product.HospitalityProductLine, {
        product: product,
        hospitalitySession: hospitalitySession,
        timeslot: timeslot,
        showOccurrences: (cov_1p1ey67r80().b[29][0]++, displayOccurences) && (cov_1p1ey67r80().b[29][1]++, hasOccurrences),
        showActions: displayActions,
        waitingListEnabled: waitingListEnabled,
        showDescription: showDescription,
        showPrice: showPrice,
        currencyCode: currencyCode,
        displayAs: item.displayAs,
        isSignedIn: isSignedIn,
        isHospitalityBundle: isHospitalityBundle,
        ecommerceGoogleTracking: ecommerceGoogleTracking,
        replaceProductNameByPerformanc: replaceProductNameByPerformance,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 362,
          columnNumber: 11
        }
      }), (cov_1p1ey67r80().b[30][0]++, withDivider) && (cov_1p1ey67r80().b[30][1]++, /*#__PURE__*/_react.default.createElement(Divider, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 378,
          columnNumber: 27
        }
      })));
    } else {
      cov_1p1ey67r80().b[28][1]++;
    }
    var _ref6 = (cov_1p1ey67r80().s[52]++, reportData),
      isReportContext = _ref6.isReportContext,
      onProductSelectChange = _ref6.onProductSelectChange,
      selectProductIds = _ref6.selectProductIds;
    var isSelected = (cov_1p1ey67r80().s[53]++, (cov_1p1ey67r80().b[31][0]++, selectProductIds) && (cov_1p1ey67r80().b[31][1]++, selectProductIds.has(product.id)));
    var isFirstItem = (cov_1p1ey67r80().s[54]++, index === 0);
    cov_1p1ey67r80().s[55]++;
    return /*#__PURE__*/_react.default.createElement(ProductBox, {
      columns: columns,
      width: gridSettings.width,
      ml: (cov_1p1ey67r80().b[33][0]++, isFirstItem) || (cov_1p1ey67r80().b[33][1]++, themeQueries.EQUILIBRIUM) ? (cov_1p1ey67r80().b[32][0]++, null) : (cov_1p1ey67r80().b[32][1]++, "".concat(_themeMapper.evolutionTheme.spacings.lg, "px")),
      key: id,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 389,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_product.ProductCard, {
      performance: performance,
      timeslot: timeslot,
      product: product,
      showOccurrences: (cov_1p1ey67r80().b[34][0]++, displayOccurences) && (cov_1p1ey67r80().b[34][1]++, hasOccurrences),
      showActions: displayActions,
      aspectRatio: aspectRatio,
      waitingListEnabled: waitingListEnabled,
      showDescription: showDescription,
      showPrice: showPrice,
      currencyCode: currencyCode,
      isSignedIn: isSignedIn,
      showDate: showDate,
      showTime: showTime,
      productTitleFontSize: productTitleFontSize,
      onActionClick: onActionClick,
      isShowSelectCheckbox: isReportContext,
      isSelected: isSelected,
      onProductSelectChange: onProductSelectChange,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      isLandingPage: isLandingPage,
      onWatchStreamOnline: onWatchStreamOnline,
      displayAs: item.displayAs,
      keyPrefix: keyPrefix,
      replaceProductNameByPerformance: replaceProductNameByPerformance,
      resaleAvailability: resaleAvailability,
      actionButtonVariant: actionButtonVariant,
      lastItemId: (cov_1p1ey67r80().b[35][0]++, items[items.length - 1].performanceId) || (cov_1p1ey67r80().b[35][1]++, items[items.length - 1].productId),
      columns: columns,
      showAsGrid: showAsGrid,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 394,
        columnNumber: 9
      }
    }));
  });
}
var Cluster = /*#__PURE__*/function (_Component) {
  function Cluster(_props) {
    var _this2;
    (0, _classCallCheck2.default)(this, Cluster);
    cov_1p1ey67r80().f[21]++;
    cov_1p1ey67r80().s[92]++;
    _this2 = _callSuper(this, Cluster, [_props]);
    (0, _defineProperty2.default)(_this2, "onLoadMoreProducts", (cov_1p1ey67r80().s[94]++, function (e) {
      cov_1p1ey67r80().f[22]++;
      cov_1p1ey67r80().s[95]++;
      e.preventDefault();
      // Accessibility: To increase UX we set focus to the last focusable product before load more, then user could continue
      // using Tab button to focus recently loaded element
      var parentCluster = (cov_1p1ey67r80().s[96]++, e.target.closest('.stx-SectionCluster'));
      cov_1p1ey67r80().s[97]++;
      if (parentCluster) {
        cov_1p1ey67r80().b[50][0]++;
        cov_1p1ey67r80().s[98]++;
        parentCluster.focus({
          preventScroll: false
        });
      } else {
        cov_1p1ey67r80().b[50][1]++;
      }
      cov_1p1ey67r80().s[99]++;
      _this2.setState(function (prevState, props) {
        cov_1p1ey67r80().f[23]++;
        cov_1p1ey67r80().s[100]++;
        return {
          itemsPerPage: prevState.itemsPerPage + props.maxItemPerPage
        };
      });
    }));
    cov_1p1ey67r80().s[93]++;
    _this2.state = {
      products: [],
      itemsPerPage: 0,
      isShownChevron: false
    };
    return _this2;
  }
  (0, _inherits2.default)(Cluster, _Component);
  return (0, _createClass2.default)(Cluster, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_1p1ey67r80().f[24]++;
      var _ref7 = (cov_1p1ey67r80().s[101]++, this.state),
        products = _ref7.products,
        itemsPerPage = _ref7.itemsPerPage,
        displayShowMoreButton = _ref7.displayShowMoreButton,
        hideShowMoreButton = _ref7.hideShowMoreButton,
        isShownChevron = _ref7.isShownChevron;
      var pagination = (cov_1p1ey67r80().s[102]++, " (".concat(Math.min(this.state.itemsPerPage, products.length), "/").concat(products.length, ")"));
      var _ref8 = (cov_1p1ey67r80().s[103]++, this.props),
        layout = _ref8.layout,
        columns = _ref8.columns,
        aspectRatio = _ref8.aspectRatio,
        maxInSlider = _ref8.maxInSlider,
        showOccurrences = _ref8.showOccurrences,
        displayActionBtn = _ref8.displayActionBtn,
        waitingListEnabled = _ref8.waitingListEnabled,
        showDescription = _ref8.showDescription,
        showPrice = _ref8.showPrice,
        currencyCode = _ref8.currencyCode,
        isSignedIn = _ref8.isSignedIn,
        showDate = _ref8.showDate,
        showTime = _ref8.showTime,
        classifyBy = _ref8.classifyBy,
        onActionClick = _ref8.onActionClick,
        sectionCode = _ref8.sectionCode,
        cluster = _ref8.cluster,
        loading = _ref8.loading,
        reportData = _ref8.reportData,
        isLandingPage = _ref8.isLandingPage,
        onWatchStreamOnline = _ref8.onWatchStreamOnline,
        ecommerceGoogleTracking = _ref8.ecommerceGoogleTracking,
        replaceProductNameByPerformance = _ref8.replaceProductNameByPerformance,
        resaleAvailability = _ref8.resaleAvailability,
        activeScreenQueries = _ref8.activeScreenQueries,
        activeScreen = _ref8.activeScreen,
        currentTheme = _ref8.currentTheme,
        themeQueries = _ref8.themeQueries,
        actionButtonVariant = _ref8.actionButtonVariant,
        fullWidthActionButtonBreakpoint = _ref8.fullWidthActionButtonBreakpoint;
      var keyPrefix = (cov_1p1ey67r80().s[104]++, [sectionCode, cluster.code].join('-'));
      var showAsCarousel = (cov_1p1ey67r80().s[105]++, layout === 'SLIDER');
      var showAsSlider = (cov_1p1ey67r80().s[106]++, layout === 'CARD');
      var showAsListProductLine = (cov_1p1ey67r80().s[107]++, layout === 'PAGINATED_LIST');
      var disabledLoadMoreBtn = (cov_1p1ey67r80().s[108]++, itemsPerPage >= products.length);
      var gFilmStrip = (cov_1p1ey67r80().s[109]++, 'g-filmStrip');
      var filmStrip1Id = (cov_1p1ey67r80().s[110]++, (0, _utils.uuid)(gFilmStrip));
      var filmStrip2Id = (cov_1p1ey67r80().s[111]++, (0, _utils.uuid)(gFilmStrip));
      var carouselRatio = (cov_1p1ey67r80().s[112]++, (cov_1p1ey67r80().b[52][0]++, themeQueries.EVOLUTION) && ((cov_1p1ey67r80().b[52][1]++, activeScreenQueries.xs) || (cov_1p1ey67r80().b[52][2]++, activeScreenQueries.sm)) ? (cov_1p1ey67r80().b[51][0]++, 'SQUARE') : (cov_1p1ey67r80().b[51][1]++, 'LANDSCAPE'));
      var showAsGrid = (cov_1p1ey67r80().s[113]++, (cov_1p1ey67r80().b[53][0]++, !showAsCarousel) && (cov_1p1ey67r80().b[53][1]++, !showAsSlider) && (cov_1p1ey67r80().b[53][2]++, !showAsListProductLine));
      cov_1p1ey67r80().s[114]++;
      var onSlideChange = function onSlideChange(isShown) {
        cov_1p1ey67r80().f[25]++;
        cov_1p1ey67r80().s[115]++;
        if (themeQueries.EQUILIBRIUM) {
          cov_1p1ey67r80().b[54][0]++;
          cov_1p1ey67r80().s[116]++;
          return;
        } else {
          cov_1p1ey67r80().b[54][1]++;
        }
        cov_1p1ey67r80().s[117]++;
        _this3.setState(function () {
          cov_1p1ey67r80().f[26]++;
          cov_1p1ey67r80().s[118]++;
          return {
            isShownChevron: isShown
          };
        });
      };
      cov_1p1ey67r80().s[119]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        className: (0, _utils.classNames)({
          showAsCarousel: showAsCarousel,
          showAsSlider: showAsSlider,
          showAsListProductLine: showAsListProductLine,
          showAsGrid: showAsGrid
        }),
        activeScreen: activeScreen,
        columns: columns,
        fullWidthActionButtonBreakpoint: fullWidthActionButtonBreakpoint,
        isReportContext: (cov_1p1ey67r80().b[55][0]++, reportData) && (cov_1p1ey67r80().b[55][1]++, reportData.isReportContext),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 617,
          columnNumber: 7
        }
      }, (cov_1p1ey67r80().b[56][0]++, showAsCarousel) && (cov_1p1ey67r80().b[56][1]++, products.length > 1) && (cov_1p1ey67r80().b[56][2]++, /*#__PURE__*/_react.default.createElement(FullWidthFilmStrip, {
        className: filmStrip1Id,
        childHeightSelector: ".".concat(filmStrip1Id, " .stx-ProductImage"),
        accessibilityChildrenSelector: ".stx-ProductCard",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 630,
          columnNumber: 13
        }
      }, renderItems(keyPrefix, (0, _take.default)(products, maxInSlider), columns, carouselRatio, layout, showOccurrences, waitingListEnabled, showDescription, showPrice, displayActionBtn, currencyCode, isSignedIn, showDate, showTime, classifyBy, onActionClick, reportData, isLandingPage, onWatchStreamOnline, ecommerceGoogleTracking, replaceProductNameByPerformance, resaleAvailability, {
        currentTheme: currentTheme,
        themeQueries: themeQueries
      }, actionButtonVariant))), (cov_1p1ey67r80().b[57][0]++, showAsCarousel) && (cov_1p1ey67r80().b[57][1]++, products.length < 2) && (cov_1p1ey67r80().b[57][2]++, renderItems(keyPrefix, products, columns, carouselRatio, layout, showOccurrences, waitingListEnabled, showDescription, showPrice, displayActionBtn, currencyCode, isSignedIn, showDate, showTime, classifyBy, onActionClick, reportData, isLandingPage, onWatchStreamOnline, ecommerceGoogleTracking, replaceProductNameByPerformance, resaleAvailability, {
        currentTheme: currentTheme,
        themeQueries: themeQueries
      }, actionButtonVariant)), (cov_1p1ey67r80().b[58][0]++, showAsSlider) && (cov_1p1ey67r80().b[58][1]++, /*#__PURE__*/_react.default.createElement(FullWidthFilmStrip, {
        itemSpacing: themeQueries.EVOLUTION ? (cov_1p1ey67r80().b[59][0]++, _themeMapper.evolutionTheme.spacings.lg) : (cov_1p1ey67r80().b[59][1]++, 0),
        className: filmStrip2Id,
        childHeightSelector: ".".concat(filmStrip2Id, " .stx-ProductImage"),
        onHideChevron: onSlideChange,
        accessibilityChildrenSelector: ".stx-ProductCard",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 697,
          columnNumber: 11
        }
      }, renderItems(keyPrefix, products, columns, aspectRatio, layout, showOccurrences, waitingListEnabled, showDescription, showPrice, displayActionBtn, currencyCode, isSignedIn, showDate, showTime, classifyBy, onActionClick, reportData, isLandingPage, onWatchStreamOnline, ecommerceGoogleTracking, replaceProductNameByPerformance, resaleAvailability, {
        currentTheme: currentTheme,
        themeQueries: themeQueries
      }, actionButtonVariant, isShownChevron))), (cov_1p1ey67r80().b[60][0]++, showAsGrid) && (cov_1p1ey67r80().b[60][1]++, (cov_1p1ey67r80().b[62][0]++, !loading) && (cov_1p1ey67r80().b[62][1]++, products.length === 0) ? (cov_1p1ey67r80().b[61][0]++, /*#__PURE__*/_react.default.createElement(NoResultsWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 737,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.ProductList.notFound",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 738,
          columnNumber: 15
        }
      }))) : (cov_1p1ey67r80().b[61][1]++, renderItems(keyPrefix, products, columns, aspectRatio, layout, showOccurrences, waitingListEnabled, showDescription, showPrice, displayActionBtn, currencyCode, isSignedIn, showDate, showTime, classifyBy, onActionClick, reportData, isLandingPage, onWatchStreamOnline, ecommerceGoogleTracking, replaceProductNameByPerformance, resaleAvailability, {
        currentTheme: currentTheme,
        themeQueries: themeQueries
      }, actionButtonVariant, isShownChevron, showAsGrid))), (cov_1p1ey67r80().b[63][0]++, showAsListProductLine) && (cov_1p1ey67r80().b[63][1]++, (cov_1p1ey67r80().b[65][0]++, !loading) && (cov_1p1ey67r80().b[65][1]++, products.length === 0) ? (cov_1p1ey67r80().b[64][0]++, /*#__PURE__*/_react.default.createElement(NoResultsWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 775,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.ProductList.notFound",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 776,
          columnNumber: 15
        }
      }))) : (cov_1p1ey67r80().b[64][1]++, /*#__PURE__*/_react.default.createElement(FullWidthFlex, {
        flexDirection: "column",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 779,
          columnNumber: 13
        }
      }, renderItems(keyPrefix, hideShowMoreButton ? (cov_1p1ey67r80().b[66][0]++, products) : (cov_1p1ey67r80().b[66][1]++, (0, _take.default)(products, itemsPerPage)), 1, aspectRatio, layout, showOccurrences, waitingListEnabled, showDescription, showPrice, displayActionBtn, currencyCode, isSignedIn, showDate, showTime, classifyBy, onActionClick, reportData, isLandingPage, onWatchStreamOnline, ecommerceGoogleTracking, replaceProductNameByPerformance, resaleAvailability, {
        currentTheme: currentTheme,
        themeQueries: themeQueries
      }, actionButtonVariant) // 1 column for paginated layout
      , (cov_1p1ey67r80().b[67][0]++, !hideShowMoreButton) && (cov_1p1ey67r80().b[67][1]++, displayShowMoreButton) && (cov_1p1ey67r80().b[67][2]++, /*#__PURE__*/_react.default.createElement(MoreBox, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 812,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.onLoadMoreProducts,
        disabled: disabledLoadMoreBtn,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 813,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.Section.more",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 814,
          columnNumber: 23
        }
      }), pagination)))))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _ref12;
      cov_1p1ey67r80().f[14]++;
      var _ref9 = (cov_1p1ey67r80().s[56]++, props),
        layout = _ref9.layout,
        cluster = _ref9.cluster,
        randomOrder = _ref9.randomOrder,
        maxItemPerPage = _ref9.maxItemPerPage,
        sortByDate = _ref9.sortByDate,
        hideShowMoreButton = _ref9.hideShowMoreButton,
        sectionCode = _ref9.sectionCode;
      // the cluster contains a list of items. Each of them should be displayed
      // get a list of object to display
      var _ref10 = (cov_1p1ey67r80().s[57]++, cluster),
        items = _ref10.items;
      cov_1p1ey67r80().s[58]++;
      if (sectionCode === 'SERVICE') {
        cov_1p1ey67r80().b[36][0]++;
        cov_1p1ey67r80().s[59]++;
        items = items.filter(function (item) {
          cov_1p1ey67r80().f[15]++;
          cov_1p1ey67r80().s[60]++;
          return item.product.code !== 'GIFT_AID';
        });
      } else {
        cov_1p1ey67r80().b[36][1]++;
      }
      /*
       *  productsList contains a list of object that contains the product info + perf/timeslot info if display as performance.
       */
      var productsList = (cov_1p1ey67r80().s[61]++, items.map(function (item) {
        cov_1p1ey67r80().f[16]++;
        var _ref11 = (cov_1p1ey67r80().s[62]++, item),
          product = _ref11.product,
          displayAs = _ref11.displayAs;
        // If we have to display them as performance, it means that we should show each performance as a product
        // add the list of performance or timeslot as product itself
        cov_1p1ey67r80().s[63]++;
        if (displayAs === 'PERFORMANCE') {
          cov_1p1ey67r80().b[37][0]++;
          cov_1p1ey67r80().s[64]++;
          if ((cov_1p1ey67r80().b[39][0]++, product.performances) && (cov_1p1ey67r80().b[39][1]++, product.performances.length > 0)) {
            cov_1p1ey67r80().b[38][0]++;
            cov_1p1ey67r80().s[65]++;
            return product.performances.map(function (performance) {
              cov_1p1ey67r80().f[17]++;
              cov_1p1ey67r80().s[66]++;
              return {
                displayAs: item.displayAs,
                product: item.product,
                productId: item.product.id,
                performanceId: performance.id,
                firstDate: performance.start,
                performance: performance
              };
            });
          } else {
            cov_1p1ey67r80().b[38][1]++;
            cov_1p1ey67r80().s[67]++;
            if ((cov_1p1ey67r80().b[41][0]++, product.timeslots) && (cov_1p1ey67r80().b[41][1]++, product.timeslots.length > 0)) {
              cov_1p1ey67r80().b[40][0]++;
              cov_1p1ey67r80().s[68]++;
              return product.timeslots.map(function (timeslot) {
                cov_1p1ey67r80().f[18]++;
                cov_1p1ey67r80().s[69]++;
                return {
                  displayAs: item.displayAs,
                  product: item.product,
                  productId: item.product.id,
                  timeslotId: timeslot.id,
                  firstDate: timeslot.start,
                  timeslot: timeslot
                };
              });
            } else {
              cov_1p1ey67r80().b[40][1]++;
            }
          }
          cov_1p1ey67r80().s[70]++;
          return {
            displayAs: item.displayAs,
            product: item.product,
            productId: item.product.id,
            firstDate: item.product.firstDate
          };
        } else {
          cov_1p1ey67r80().b[37][1]++;
        }
        /* Display hospitality session as product */
        cov_1p1ey67r80().s[71]++;
        if ((cov_1p1ey67r80().b[43][0]++, product.sessions) && (cov_1p1ey67r80().b[43][1]++, product.sessions.length > 0)) {
          cov_1p1ey67r80().b[42][0]++;
          cov_1p1ey67r80().s[72]++;
          return product.sessions.map(function (session) {
            cov_1p1ey67r80().f[19]++;
            cov_1p1ey67r80().s[73]++;
            return {
              displayAs: item.displayAs,
              product: item.product,
              productId: item.product.id,
              sessionId: session.id,
              date: session.date,
              hospitalitySession: session
            };
          });
        } else {
          cov_1p1ey67r80().b[42][1]++;
        }
        cov_1p1ey67r80().s[74]++;
        return {
          displayAs: item.displayAs,
          product: item.product,
          productId: item.product.id,
          firstDate: item.product.firstDate
        };
      }));
      cov_1p1ey67r80().s[75]++;
      productsList = (_ref12 = []).concat.apply(_ref12, (0, _toConsumableArray2.default)(productsList));
      var products = (cov_1p1ey67r80().s[76]++, productsList);
      cov_1p1ey67r80().s[77]++;
      if (randomOrder) {
        cov_1p1ey67r80().b[44][0]++;
        cov_1p1ey67r80().s[78]++;
        products = (0, _shuffle.default)(productsList);
        cov_1p1ey67r80().s[79]++;
        updatePosition(products);
      } else {
        cov_1p1ey67r80().b[44][1]++;
        cov_1p1ey67r80().s[80]++;
        if (sortByDate) {
          cov_1p1ey67r80().b[45][0]++;
          cov_1p1ey67r80().s[81]++;
          products = products.sort(function (a, b) {
            cov_1p1ey67r80().f[20]++;
            cov_1p1ey67r80().s[82]++;
            if (!(0, _is_valid.default)((0, _parse.default)(a.firstDate))) {
              cov_1p1ey67r80().b[46][0]++;
              cov_1p1ey67r80().s[83]++;
              return 1;
            } else {
              cov_1p1ey67r80().b[46][1]++;
            }
            cov_1p1ey67r80().s[84]++;
            if (!(0, _is_valid.default)((0, _parse.default)(b.firstDate))) {
              cov_1p1ey67r80().b[47][0]++;
              cov_1p1ey67r80().s[85]++;
              return -1;
            } else {
              cov_1p1ey67r80().b[47][1]++;
            }
            cov_1p1ey67r80().s[86]++;
            return (0, _format.default)(a.firstDate, 'x') - (0, _format.default)(b.firstDate, 'x');
          });
          cov_1p1ey67r80().s[87]++;
          updatePosition(products);
        } else {
          cov_1p1ey67r80().b[45][1]++;
        }
      }
      var isPaginatedLayout = (cov_1p1ey67r80().s[88]++, layout === 'PAGINATED_LIST');
      var itemsPerPage = (cov_1p1ey67r80().s[89]++, isPaginatedLayout ? (cov_1p1ey67r80().b[48][0]++, (cov_1p1ey67r80().b[49][0]++, state.itemsPerPage) || (cov_1p1ey67r80().b[49][1]++, maxItemPerPage)) : (cov_1p1ey67r80().b[48][1]++, products.length));
      var displayShowMoreButton = (cov_1p1ey67r80().s[90]++, products.length > itemsPerPage);
      cov_1p1ey67r80().s[91]++;
      return {
        products: products,
        itemsPerPage: itemsPerPage,
        displayShowMoreButton: displayShowMoreButton,
        hideShowMoreButton: hideShowMoreButton
      };
    }
  }]);
}(_react.Component);
cov_1p1ey67r80().s[120]++;
Cluster.propTypes = {
  /** Define if the card should show the occurences or not */
  showOccurrences: _propTypes.default.bool,
  /** Override the aspect ratio of images defined in the section values  */
  aspectRatio: _propTypes.default.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /** Override the randomOrder value defined in the section  */
  randomOrder: _propTypes.default.bool,
  /** The current cluster displayed */
  cluster: _section.ClusterType.isRequired,
  /** Defines if the product card should display the price or not */
  showPrice: _propTypes.default.bool,
  /** Defines if the product card should display the description or not */
  showDescription: _propTypes.default.bool,
  /** Defines if the product card should display the description or not */
  displayActionBtn: _propTypes.default.bool,
  /** Override the columns number value defined in the section  */
  columns: _propTypes.default.number,
  /** Override the columns number value defined in the section  */
  maxInSlider: _propTypes.default.number,
  /** Override the layount value defined in the section  */
  layout: _propTypes.default.oneOf(['CARD', 'SLIDER', 'DEFAULT', 'PAGINATED_LIST']),
  /** show the subscription link if no availability */
  waitingListEnabled: _propTypes.default.bool,
  /** Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string,
  /** Maximum product to display each page for paginated list section layout */
  maxItemPerPage: _propTypes.default.number,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /** Clarify how to sort the products inside a cluster  */
  classifyBy: _propTypes.default.string,
  /** to show the date of a product card */
  showDate: _propTypes.default.bool,
  /** to show the time of a product card */
  showTime: _propTypes.default.bool,
  /** to produce unique key */
  sectionCode: _propTypes.default.string.isRequired,
  /** True if still loading data */
  loading: _propTypes.default.bool,
  /** The function called when clicking on the product or occurence action */
  onActionClick: _propTypes.default.func,
  /** Option to hide show more button */
  hideShowMoreButton: _propTypes.default.bool,
  /** Option to force sorting by date */
  sortByDate: _propTypes.default.bool,
  /* Contain data for handle display and action for report management */
  reportData: _propTypes.default.shape(_productList.ReportManagementDataType),
  /** Option to use google enhance tracking to push data to data layer */
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Function to handle watch stream online */
  onWatchStreamOnline: _propTypes.default.func,
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  replaceProductNameByPerformance: _propTypes.default.bool,
  resaleAvailability: _propTypes.default.shape({}),
  /** Screen queries */
  activeScreenQueries: _utils.WithScreenQueriesType,
  activeScreen: _propTypes.default.string,
  /** Theme context */
  themeContext: _themeProvider.ThemeContextType,
  currentTheme: _propTypes.default.string.isRequired,
  themeQueries: _withThemeQueries.WithThemeQueriesType,
  /** Product Action Button */
  actionButtonVariant: _button.ButtonVariantType,
  /** number of column that action buttons not expand full width */
  fullWidthActionButtonBreakpoint: _propTypes.default.number
};
cov_1p1ey67r80().s[121]++;
Cluster.defaultProps = {
  classifyBy: 'NONE',
  aspectRatio: 'VERTICAL',
  maxInSlider: 5,
  showOccurrences: false,
  showDescription: false,
  displayActionBtn: false,
  showPrice: false,
  waitingListEnabled: null,
  columns: null,
  currencyCode: null,
  maxItemPerPage: 0,
  isSignedIn: false,
  layout: 'DEFAULT',
  randomOrder: false,
  onActionClick: null,
  hideShowMoreButton: false,
  sortByDate: false,
  showDate: undefined,
  loading: undefined,
  showTime: undefined,
  reportData: {},
  isLandingPage: false,
  onWatchStreamOnline: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {},
    useGA4: false
  },
  replaceProductNameByPerformance: false,
  resaleAvailability: {},
  themeQueries: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  activeScreenQueries: {},
  activeScreen: 'xs',
  actionButtonVariant: _button.ButtonVariant.primary,
  fullWidthActionButtonBreakpoint: Infinity
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _utils.withScreenQueries)(Cluster)));